<template>
<div class="hris-page">
  <div class="hris-page-inner">
    <div class="hris-page-header">
      <span class="hris-page-eyebrow">System Settings</span>
      <h1 class="hris-page-title">MWE-Monthly Settings</h1>
      <p class="hris-page-subtitle">Manage minimum wage earner rates by region, coverage, and sector.</p>
    </div>

    <div class="hris-toolbar">
      <q-select v-model="region" option-value="id" option-label="region_no" :options="regionOptions" label="Region" outlined dense color="green" emit-value map-options @input="getCoverage" style="min-width: 200px"></q-select>
      <q-select v-model="coverage" option-value="id" option-label="coverage" :options="coverageOptions" label="Coverage" outlined dense color="green" emit-value map-options style="min-width: 200px" @input="getSector"></q-select>
      <q-select v-model="sector" option-value="id" option-label="sector" :options="sectorOptions" label="Sector" outlined dense color="green" emit-value map-options style="min-width: 200px" @input="displayData"></q-select>
    </div>

    <div class="hris-panel">
      <h3 class="hris-panel-title">MWE-Monthly List</h3>
      <q-table
        flat
        :data="data"
        :columns="columns"
        row-key="id"
        :pagination.sync="pagination"
      >
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="id" :props="props">{{ props.row.id }}</q-td>
            <q-td key="region" :props="props">{{ props.row.region }}</q-td>
            <q-td key="coverage" :props="props">{{ props.row.coverage }}</q-td>
            <q-td key="sector" :props="props">{{ props.row.sector }}</q-td>
            <q-td key="basic" :props="props">{{ props.row.basic }}</q-td>
            <q-td key="allowance" :props="props">{{ props.row.allowance }}</q-td>
            <q-td key="deminimis" :props="props">{{ props.row.deminimis }}</q-td>
            <q-td key="total" :props="props">{{ props.row.total }}</q-td>
            <q-td key="wonumber" :props="props">{{ props.row.wonumber }}</q-td>
            <q-td key="action" :props="props">
              <q-btn flat round dense class="hris-q-ghost" @click="editDialog(props)">
                <i class="fas fa-edit"></i>
                <q-tooltip>Edit</q-tooltip>
              </q-btn>
              <q-btn flat round dense class="hris-q-ghost" @click="removeRow(props)">
                <i class="fas fa-trash"></i>
                <q-tooltip>Remove</q-tooltip>
              </q-btn>
            </q-td>
          </q-tr>
        </template>
        <template v-slot:no-data="">
          <div class="hris-empty full-width">No results found.</div>
        </template>
      </q-table>
    </div>

    <q-page-sticky position="bottom-right" :offset="[18, 18]">
      <q-btn fab icon="fas fa-plus" class="hris-q-primary" @click="addDialog"></q-btn>
    </q-page-sticky>
    <q-dialog v-model="spinner" persistent>
      <div class="hris-loading" style="background: var(--hris-surface); border-radius: var(--hris-radius); padding: 32px 44px;">
        <q-spinner color="green" size="40px"></q-spinner>
      </div>
    </q-dialog>

    <q-dialog v-model="deleted" persistent>
      <div class="hris-modal">
        <div class="hris-modal-header">
          <h2 class="hris-modal-title">Confirm Deletion</h2>
        </div>
        <div class="hris-modal-body">
          This record will be permanently deleted.
        </div>
        <div class="hris-modal-footer">
          <q-btn flat label="Cancel" class="hris-q-ghost" v-close-popup></q-btn>
          <q-btn unelevated label="Continue" class="hris-q-primary" v-close-popup @click="deletionConfirmation"></q-btn>
        </div>
      </div>
    </q-dialog>
    <AddMWEMonthlyDialog></AddMWEMonthlyDialog>
  </div>
</div>
</template>

<script>
import axios from 'axios';
import mixins from '../../mixins';
import AddMWEMonthlyDialog from './AddMWEMonthlyDialog';

export default {
	components: {
		"AddMWEMonthlyDialog": AddMWEMonthlyDialog,

	},
	data () {
		return {
			tempID:0,
			spinner:false,
			deleted:false,
			region:null,
			coverage:null,
			sector:null,
			regionOptions:[],
			coverageOptions:[],
			sectorOptions:[],
			data:[],
			type:'monthly',
			columns: [
			{ name: 'region', align: 'center', label: 'Region', field: 'region', sortable: true },
			{ name: 'coverage', align: 'center', label: 'Coverage', field: 'coverage', sortable: true },
			{ name: 'sector', align: 'center', label: 'Sector', field: 'sector' , sortable: true},
			{ name: 'basic', align: 'center', label: 'Basic', field: 'basic' , sortable: true},
			{ name: 'allowance', align: 'center', label: 'Allowance', field: 'allowance' , sortable: true},
			{ name: 'deminimis', align: 'center', label: 'Deminimis', field: 'deminimis' , sortable: true},
			{ name: 'total', align: 'center', label: 'Total', field: 'total' , sortable: true},
			{ name: 'wonumber', align: 'center', label: 'W.O Number', field: 'wonumber' , sortable: true},
			{ name: 'action', align: 'center', label: 'Action', field: '', sortable: true },
			],
			pagination: {
				rowsPerPage: 20
			},
		}
	},

	created(){
		this.eventHub.$on('updateList', this.displayData);
		this.displayRegions()
	},

	methods: {

		addDialog(emp) {
			this.eventHub.$emit('AddMWEMonthly',{type:'add',status:true,emp:''});
		},

		editDialog(emp) {
			this.eventHub.$emit('AddMWEMonthly',{type:'edit',status:true,emp:emp});
		},

		displayRegions: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/regions`)
			.then((res) => {

				this.regionOptions = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})
		},

		getCoverage:function(){
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/region/sector/${this.region}`)
			.then((res) => {
				this.coverage = ''
				this.sector = ''
				this.coverageOptions = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})
		},

		getSector:function(){
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/sectors/${this.coverage}`)
			.then((res) => {
				this.sector = ''
				this.sectorOptions = res.data.data;
				setTimeout(() => {
					this.spinner = false
				},500)
			})
		},



		displayData: function() {
			axios.create({
				baseURL: this.apiUrl,
				headers: {
					'Authorization': `Bearer ${this.token}`
				}})
			.get(`/admin/mwe/monthly/${this.region}/${this.coverage}/${this.sector}/${this.type}`)
			.then((res) => {
				this.data = res.data.mwemonthly;
				setTimeout(() => {
					this.spinner = false
				},500)
			})

		},

		removeRow:function(obj){
			console.log(obj.row.od)
			this.deleted = true
			this.tempID = obj.row.id

		},

		deletionConfirmation:function(){
			this.spinner = true;
			let formData = new FormData();
			formData.append("tempID", this.tempID);
			axios.create({
				baseURL : this.apiUrl,
				headers : {'Authorization' : `Bearer ${this.token}`}
			}).post('/admin/mwe/delete',formData)
			.then((res) => {
				this.tempID = 0
				this.spinner = false
				this.displayData()
			});
		}

	}
}
</script>
<style>
.caps {
	text-transform: uppercase
}
</style>